import { publicClient } from "./client";

const fetchPromotions = () => publicClient.get(`/banners`);

export { fetchPromotions };
